import { Box } from '@mui/system';
import React, { useRef, useState } from 'react';
import { CommonPagesWrapper, LoginButton, MainPoliciesWrapper, PoliciesFormWrapper } from '../../pages/Login/Login.styles';
import { AuthContainerStyled } from '../styled-components/AuthContainerStyled';
import { ReactComponent as LogoVipr } from '../../assets/img/logo-vipr.svg';
import { ScrollGridItem, StyledTyphography } from '../../pages/SysSecurityTerms/SysSecurityTerms.styles';
import { Grid, Typography } from '@mui/material';

type PoliciesSharedViewProps = {
  onSubmit: (e: any) => void;
  loading: boolean;
  content: string | React.ReactNode;
};
const PoliciesSharedView = (props: PoliciesSharedViewProps) => {
  const { onSubmit, loading, content } = props;

  const [reachedBottom, setReachedBottom] = useState<boolean>(false);
  const contentInnerRef = useRef<HTMLDivElement | null>(null);

  const onScroll = () => {
    if (contentInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentInnerRef.current;

      if (scrollTop + clientHeight === scrollHeight) {
        setReachedBottom(true);
      }
    }
  };

  return (
    <AuthContainerStyled>
      <CommonPagesWrapper>
        <MainPoliciesWrapper style={{ maxWidth: '965px' }}>
          <Box color="base.errorPrimary">
            <LogoVipr style={{ height: '56px', width: '56px' }} />
          </Box>
          <PoliciesFormWrapper onSubmit={onSubmit} style={{ maxWidth: '965px', padding: '80px' }}>
            <ScrollGridItem
              onScroll={onScroll}
              ref={contentInnerRef}
              item
              xs={12}>
              <StyledTyphography>
                {content}
              </StyledTyphography>
            </ScrollGridItem>
            <Grid
              flexDirection={'row'}
              gap={3}
              container
            >
              <LoginButton
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={!reachedBottom}
                loading={loading}
                loadingPosition="end"
              >
              Accept
              </LoginButton>
            </Grid>
          </PoliciesFormWrapper>
          <Typography variant="tsm" color="#98A2B3">
              © VIPR.ai 2025
          </Typography>
        </MainPoliciesWrapper>
      </CommonPagesWrapper>
    </AuthContainerStyled>
  );
};

export default PoliciesSharedView;
